import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class StoreOnboardingProgressionsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/store_onboarding_progressions", { params: toSnakeCase(params) });
  }
}

export default new StoreOnboardingProgressionsService();
